import { render, staticRenderFns } from "./tel.vue?vue&type=template&id=5d8e6e74&scoped=true&"
import script from "./tel.vue?vue&type=script&lang=js&"
export * from "./tel.vue?vue&type=script&lang=js&"
import style0 from "./tel.vue?vue&type=style&index=0&id=5d8e6e74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8e6e74",
  null
  
)

export default component.exports